module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ce4c8734aa6e76ab82c03bbe3488b8c1.png";